import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { IconButton, } from '@mui/material';
import closeButton from '../../Assets/popup-close.svg';
import noImg from '../../Assets/NoPreviewImage.svg';
import PanZoom from 'react-easy-panzoom';
import SubflowTemplateServiceController from '../../Controllers/SubflowTemplateService';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const Preview = ({ openPre, closePre, id, source, localView }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (openPre) {
      if (localView) {
        const dataUrl = localStorage.getItem("flowImage");
        if (dataUrl) {
          setImageSrc(dataUrl);
        } else {
          console.error("No image data found in local storage");
        }
      }
      else {
        console.log("id", id);
        getImg();
      }

    } else {
      console.error("No image data found in local storage");
    }
  }, [openPre]);

  const subflowTempcont = new SubflowTemplateServiceController();

  const getImg = async () => {
    setLoading(true);
    setError(null);

    try {
      console.log(id, source);
      let base64Data = await subflowTempcont.getPreviewImg(id, source);
      base64Data = base64Data.replace(/"/g, '');
      console.log(base64Data);

      console.log('Received base64 prefix:', base64Data.substring(0, 20));
      console.log('Base64 length:', base64Data, base64Data.length);

      if (!base64Data || typeof base64Data !== 'string') {
        throw new Error('Invalid response format');
      }

      // Clean the string and add data URL prefix if needed
      const cleanBase64 = base64Data.trim();
      const imageUrl = cleanBase64.startsWith('data:image/')
        ? cleanBase64
        : `data:image/jpeg;base64,${base64Data}`;
      console.log(cleanBase64, imageUrl, cleanBase64.length, imageUrl.length);

      // Validate base64 format
      const base64Pattern = /^data:image\/(jpeg|jpg|png|gif);base64,/;
      if (!base64Pattern.test(imageUrl)) {
        console.log('invalid if cond');
        throw new Error('Invalid base64 image format');
      }

      // Validate by loading the image
      // await new Promise((resolve, reject) => {
      //   const img = new Image();
      //   img.onload = resolve;
      //   img.onerror = () => reject(new Error('Failed to load image data'));
      //   img.src = imageUrl;
      // });

      setImageSrc(imageUrl);
    } catch (error) {
      console.error('Error loading image:', error);
      setError(error.message);
      setImageSrc(noImg);
    } finally {
      setLoading(false);
    }
  };


  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    closePre();
  };

  return (
    <Dialog
      open={openPre}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      slotProps={{
        backdrop: {
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.01)',
            boxShadow: "20px 20px rgba(0, 0, 0, 0.5)"
          }, // Adjust the opacity here

        },
      }}
      style={{ zIndex: 5000 }}
      maxWidth="md" // Set the maximum width to large
      fullWidth // Make the dialog take up the full width of its container
    >
      <DialogTitle>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0px 5px' }}>
          <p>Preview</p>
          <IconButton onClick={closePre}><img src={closeButton} alt='close-button' /></IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ height: '400px', width: '98%', background: '#F6F7FC', border: '1px solid #757EA5', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
          {imageSrc ? (
            <PanZoom
              enableBoundingBox
              boundaryRatioVertical={0.8}
              boundaryRatioHorizontal={0.8}
              minZoom={0.5}
              maxZoom={3}
              zoomSpeed={1}
              realPinch
              disableScrollZoom={false}
              disableDoubleClickZoom={true}
              onPanStart={() => console.log('Pan started')}
              onPan={() => console.log('Panning')}
              onPanEnd={() => console.log('Pan ended')}
            >
              <img src={imageSrc} alt="Flow Image" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />

            </PanZoom>
          ) : 'Loading...'}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default Preview; 